export default __webpack_public_path__ + "static/media/fullscreenIcon.c6da15d3.svg";